import CommonHeading from "../../../../Components/CommonHeading";
import Selector from "./Select";
import TableHead from "./TableHead";
import { useFormik } from "formik";
import * as Yup from "yup";
import Searchbar from "../../../../Components/Searchbar";
import { useCallback } from "react";
import { useMemo } from "react";
import { useTaskBookStore } from "../../../../Store/TaskBookStore/TaskBookStore";
import { useTranslation } from "react-i18next";

export default function Heading() {
  const {
    getSubjectDetails,
    updateParams,
    ageGroup,
    lessonMonths,
    queryParams,
    setLoading,
  } = useTaskBookStore();

  const { t } = useTranslation();

  const searchAction = useCallback(async (payload) => {
    updateParams({ search: payload.term, page: 1 });
    setLoading(true);
    await getSubjectDetails(
      new URLSearchParams({
        ...queryParams,
        page: 1,
        search: payload.term,
      }).toString()
    );
    setLoading(false);
  });

  const initialValues = {
    term: "",
  };
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      term: Yup.string().min(1, t("Qidiruvni kiriting!")),
    }),
    onSubmit: (values) => {
      searchAction({
        term: values.term,
      });
    },
  });

  const handleChange = (e) => {
    formik.setFieldValue("term", e.target.value);
    searchAction({
      term: e.target.value,
    });
  };

  const ageGroupOptions = useMemo(() => {
    return (
      ageGroup?.map((element) => ({
        label: element.name,
        value: element.value,
      })) || []
    );
  }, [ageGroup]);

  const lessonMonthsOptions = useMemo(() => {
    return (
      lessonMonths?.map((element) => ({
        label: element.name,
        value: element.value,
      })) || []
    );
  }, [lessonMonths]);

  return (
    <CommonHeading
      topItems={
        <>
          <Searchbar
            value={formik.values.term}
            handleChange={(e) => handleChange(e)}
            handleSubmit={formik.handleSubmit}
          />
          <Selector options={ageGroupOptions} property={t("Guruh turlari")} />
          <Selector options={lessonMonthsOptions} property={t("Oylar")} />
        </>
      }
      tableHead={<TableHead />}
    />
  );
}
